import { useEffect, useState } from "react";
import { CustomInputProps } from "./CustomInputProps";
import styles from "./CustomInput.module.scss";
import classNames from "classnames";
import { EInputType } from "../../interfaces/enum";

const CustomInput = ({
  id,
  value,
  setValue,
  placeholder,
  inputType,
  errorMessage,
  onClickEnter,
}: CustomInputProps) => {
  const [error, setError] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue(e);
    if (e.target.value.length !== 0) {
      setError(false);
    }
  };

  const handleBlur = () => {
    setError(value.length === 0);
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();
  };

  useEffect(() => {
    const input = document.getElementById(id);
    input?.addEventListener("keydown", (event) => {
      if (event.key === "Enter") {
        if (onClickEnter) onClickEnter();
      }
    });
  }, [id, onClickEnter]);

  return (
    <form onSubmit={handleSubmit} className={classNames(styles.container)}>
      <input
        className={classNames(styles.input, error && styles.error)}
        id={id}
        value={value}
        name={inputType}
        onChange={handleChange}
        onBlur={handleBlur}
        type={
          inputType === EInputType.TEXT ? EInputType.TEXT : EInputType.PASSWORD
        }
        placeholder={placeholder}
        autoComplete="on"
      />
      <div className={classNames(styles.errorMessage, "fade", error && "show")}>
        {errorMessage}
      </div>
    </form>
  );
};

export default CustomInput;
